module.exports = __webpack_public_path__ + "img/meta-html-css-in-depth.2ae61073.png";